// extracted by mini-css-extract-plugin
module.exports = {"boxTools":"_3vQCQx6X8cnLxFQ7Xn2xp1","tools":"_3o7BdJBLpC4FS7rmPGwOI9"};